import { SvgRendererComponent } from "src/app/shared/components/ag-grid/svg-renderer/svg-renderer.component";
import {
    AgColDefsI,
    AgGridI,
  } from "../../../app/shared/components/ag-grid/ag-grid.model";

// const TemplateName: AgColDefsI = {
//     headerName: "Template Name",
//     field: "TemplateName",
//     sortable: true,
//     suppressMovable: false,
//     tooltipField: "TemplateName",
//     width: 100,
//     cellStyle: { paddingLeft: "2.6rem", color: "#646E76" },
//     cellRenderer: (params) =>params.value === "" || params.value === null? "<p>&#8212;</p>": params.value,
// };

const TemplateNameColumn: AgColDefsI = {
  headerName: "Template Name",
  field: "templateName",
  sortable: true,
  headerCheckboxSelection: true,
  lockPosition: "left",
  suppressMovable: true,
  lockPinned: true,
  minWidth : 1400,
  resizable:false,

  checkboxSelection: function (params) {
    return !params?.data?.isExpandedRows;
  },
  cellStyle: {
    paddingLeft: "1.2em",
  },
  tooltipField: "templateName",
 // width: 450,
  // cellRenderer: MailingListRendererComponent,
  cellRenderer: (params) =>params.value === "" || params.value === null? "<p>&#8212;</p>": params.value,

};

const EditDeleteColumn: AgColDefsI = {
    headerName: "",
    field: "editDeleteColumn",
    width: 220,
    lockPinned: true,
    suppressMovable: false,
    // cellClass: "d-flex justify-content-end",
    // pinned: 'right',
    lockPosition:"right",
    // pinned:"right",
    cellStyle: {'color': '#646E76' },
    cellRenderer:SvgRendererComponent,
    cellRendererParams:{edit:true,delete:false},
    // resizable:false,
  };


export const ColDefsTemplate: AgColDefsI[] = [
    TemplateNameColumn ,
    EditDeleteColumn
];

export const AgGridDataModelTemplate: AgGridI = {
    colDefs: ColDefsTemplate,
    rowSelection: "multiple",
}